var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNuevo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#efebf6;opacity:.715}.cls-2{opacity:.966}.cls-3,.cls-6{fill:none}.cls-3{stroke:#7644c9;stroke-width:2.5px}.cls-4{fill:#7644c9}.cls-5{stroke:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_nuevo",
    transform: "translate(-43.5 -147.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_196",
    cx: 15,
    cy: 15,
    r: 15,
    className: "cls-1",
    "data-name": "Elipse 196",
    transform: "translate(44 148)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_731",
    className: "cls-2",
    "data-name": "Grupo 731",
    transform: "translate(46 150)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_136",
    className: "cls-3",
    "data-name": "Elipse 136"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 14.25,
    className: "cls-6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1431",
    d: "M14.374-15.179a1.172 1.172 0 0 1 .865.343 1.172 1.172 0 0 1 .343.865 1.172 1.172 0 0 1-.343.865 1.172 1.172 0 0 1-.865.343h-4.283v4.255a1.219 1.219 0 0 1-.343.879 1.149 1.149 0 0 1-.865.357 1.149 1.149 0 0 1-.865-.357 1.219 1.219 0 0 1-.343-.879v-4.255H3.392a1.172 1.172 0 0 1-.865-.343 1.172 1.172 0 0 1-.343-.865 1.172 1.172 0 0 1 .343-.865 1.172 1.172 0 0 1 .865-.343h4.283v-4.283a1.172 1.172 0 0 1 .343-.865 1.172 1.172 0 0 1 .865-.343 1.172 1.172 0 0 1 .865.343 1.172 1.172 0 0 1 .343.865v4.283z",
    className: "cls-4",
    "data-name": "Trazado 1431",
    transform: "translate(3.965 26.893)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNuevo);
export default __webpack_public_path__ + "static/media/ic_nuevo.72d09fd29c2089f38ef49f0d83c1e00c.svg";
export { ForwardRef as ReactComponent };